'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Validation$package$IronSample$1(curenncyCode, optional, optionalInt, doubleGreaterThanEight, optionalDoublePositive, latLong) {
  this.tc = null;
  this.tf = null;
  this.th = null;
  this.td = 0.0;
  this.tg = null;
  this.te = null;
  this.tc = curenncyCode;
  this.tf = optional;
  this.th = optionalInt;
  this.td = doubleGreaterThanEight;
  this.tg = optionalDoublePositive;
  this.te = latLong;
}
export { $c_Lsamples_Validation$package$IronSample$1 as $c_Lsamples_Validation$package$IronSample$1 };
$p = $c_Lsamples_Validation$package$IronSample$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Validation$package$IronSample$1;
/** @constructor */
function $h_Lsamples_Validation$package$IronSample$1() {
}
export { $h_Lsamples_Validation$package$IronSample$1 as $h_Lsamples_Validation$package$IronSample$1 };
$h_Lsamples_Validation$package$IronSample$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 136772786);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.tc));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.tf));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.th));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().qW(this.td));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.tg));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.te));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 6);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Validation$package$IronSample$1)) {
    if ((this.tc === x$0.tc)) {
      var x = this.tf;
      var x$2 = x$0.tf;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.th;
      var x$4 = x$0.th;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.td === x$0.td))) {
      var x$5 = this.tg;
      var x$6 = x$0.tg;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.te;
      var x$8 = x$0.te;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 6;
});
$p.o = (function() {
  return "IronSample";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.tc;
      break;
    }
    case 1: {
      return this.tf;
      break;
    }
    case 2: {
      return this.th;
      break;
    }
    case 3: {
      return this.td;
      break;
    }
    case 4: {
      return this.tg;
      break;
    }
    case 5: {
      return this.te;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Validation$package$IronSample$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eu)));
}
export { $isArrayOf_Lsamples_Validation$package$IronSample$1 as $isArrayOf_Lsamples_Validation$package$IronSample$1 };
var $d_Lsamples_Validation$package$IronSample$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Validation$package$IronSample$1, "samples.Validation$package$IronSample$1", ({
  eu: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Validation$package$IronSample$1 as $d_Lsamples_Validation$package$IronSample$1 };
